import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Saves the server-rendered streak count into localStorage AND mirrors it
// to the native side instantly (over the existing nav-bar bridge
// component), so the native streak chip is already correct the moment the
// user navigates back to the dashboard — no waiting, no flash.
//
// The count always comes from the server (rendered into the data attribute);
// this controller never computes anything — it only stores the latest value.
export default class extends BridgeComponent {
  static component = "nav-bar"
  static values = { count: Number }

  connect() {
    super.connect()
    localStorage.setItem("streak_count", this.countValue)
    this.send("updateCounts", { streakCount: this.countValue })
  }

  // A streak fix changes the count without a page load (streak_fix_controller);
  // same store-and-mirror, with the number the server sent back.
  update(count) {
    this.countValue = count
    localStorage.setItem("streak_count", count)
    this.send("updateCounts", { streakCount: count })
  }
}
